var htmxPostPomodoro = (url, action) => {
    // action can be: play-pause-toggle, stop, restart
    htmx.ajax(url, 'post', { action: action });
}

var pomodoroHandler = () => {
    const controls = document.getElementById('pomodoroControlas');
    if (!controls) {
        return;
    }
    const playPauseButton = controls.querySelector('.play-pause');
    const stopButton = controls.querySelector('.stop');
    const restart = controls.querySelector('.restart');
    const url = controls.getAttribute('data-controls-url');

    playPauseButton.addEventListener('click', () => {
        htmxPostPomodoro(url, 'play-pause-toggle');
    });

    stopButton.addEventListener('click', () => {
        htmxPostPomodoro(url, 'stop');
        console.warn('stop');
    });

    restart.addEventListener('click', () => {
        htmxPostPomodoro(url, 'restart');
    });
}